import { render, staticRenderFns } from "./purchase-order-dialog.vue?vue&type=template&id=48b7b166&scoped=true&"
import script from "./purchase-order-dialog.vue?vue&type=script&lang=js&"
export * from "./purchase-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./purchase-order-dialog.vue?vue&type=style&index=0&id=48b7b166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7b166",
  null
  
)

export default component.exports